export default __webpack_public_path__ + "static/media/comment-timer.f4f3d0d2.svg";